// extracted by mini-css-extract-plugin
module.exports = {"list":"ProjectDownloadsBlock_list__VOpUl","item":"ProjectDownloadsBlock_item__hfKKF","link":"ProjectDownloadsBlock_link__LOycT"};